import gql from 'graphql-tag';
import { graphql } from '../utils/fetch';
import { userInfo } from '../utils/auth';

export default {
  getNotifyMessage({ getters, commit }) {
    let rval = null;
    if (getters.notify.message) {
      rval = Object.assign({}, getters.notify);
      if (!rval.type) {
        rval.type = 'is-success';
      }

      commit('notify', { message: null, type: null });
    }

    return Promise.resolve(rval);
  },

  fetchInitialData({ getters, commit, rootGetters }) {
    return new Promise((resolve, reject) => {
      if (getters.initDataLoaded) {
        return resolve();
      }

      // Only fetch the default id if we don't already have one
      let queryField = '';
      if (!rootGetters['shoppingList/defaultShoppingListId']) {
        queryField = 'defaultShoppingListId';
      }

      return graphql.query({
        query: gql`{
          initialData {
            categories
            ${queryField}
          }
        }`,
      }).then(({ data: { initialData } }) => {
        commit('categoryNames', initialData.categories);
        if (queryField) {
          commit('shoppingList/defaultShoppingListId', initialData.defaultShoppingListId);
        }

        resolve();
      }).catch(err => reject(err));
    });
  },

  fetchUserInfo({ getters, commit }) {
    return new Promise((resolve) => {
      const u = getters.user;
      if (u) {
        resolve(u);
      } else {
        userInfo().then((user) => {
          commit('user', user);
          resolve(user);
        });
      }
    });
  },

  typeaheadQuery({ commit, state }, text) {
    state.typeaheadCurrentQuery = text;
    if (!text) {
      return Promise.resolve({});
    }

    return graphql.query({
      query: gql`query FoodItems($text: String) {
        typeaheadFoodItems(text: $text) {
          id
          name
          type
        }
      }`,
      variables: {
        text,
      },
    })
    .then((results) => {
      if (state.typeaheadCurrentQuery === text) {
        const catRegex = new RegExp(`^${text}`, 'i');
        const data = {
          foodItems: results.data.typeaheadFoodItems,
          categories: state.categoryNames.filter(cat => cat.match(catRegex)),
          query: text,
        };

        commit('typeaheadResults', data);
        return data;
      }

      return {};
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js